import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { TCreateMediaFile, TMediaFileBase } from '@onesource/schemas';
import { axiosServiceInstance } from '../axios';
import { MEDIA_ENTITY } from './entity';

export const useCreateMediaFileMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<TMediaFileBase, Error, TCreateMediaFile>({
    mutationFn: async (dto: TCreateMediaFile) => {
      const res = await axiosServiceInstance.post<TMediaFileBase>(`/${MEDIA_ENTITY}`, dto);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [MEDIA_ENTITY, 'list'], exact: false });
    },
  });
};
